;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	closeAddDashboardViewDialog,
	closeCreateDataProviderDialog,
	closeDeleteDashboardViewDialog,
	closeDeleteDataProviderDialog,
	closeEditDashboardViewDialog,
	closeInviteMembersSheet,
	closeLeaderboardConfiguration,
	closeShareViewDialog,
} from "@/features/onboarding-tours/orchestrator/tour-step-actions";

export const TOUR_OVERLAY_GROUPS = {
	addDashboardView: "add-dashboard-view",
	createDataProvider: "create-data-provider",
	deleteDashboardView: "delete-dashboard-view",
	deleteDataProvider: "delete-data-provider",
	editDashboardView: "edit-dashboard-view",
	inviteSheet: "invite-sheet",
	leaderboardConfig: "leaderboard-config",
	shareDialog: "share-dialog",
} as const;

export type TourOverlayGroupId =
	(typeof TOUR_OVERLAY_GROUPS)[keyof typeof TOUR_OVERLAY_GROUPS];

export function closeTourOverlayGroup({
	overlayGroup,
}: {
	overlayGroup: string;
}): void {
	if (overlayGroup === TOUR_OVERLAY_GROUPS.inviteSheet) {
		closeInviteMembersSheet();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.leaderboardConfig) {
		closeLeaderboardConfiguration();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.shareDialog) {
		closeShareViewDialog();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.addDashboardView) {
		closeAddDashboardViewDialog();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.createDataProvider) {
		closeCreateDataProviderDialog();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.deleteDataProvider) {
		closeDeleteDataProviderDialog();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.editDashboardView) {
		closeEditDashboardViewDialog();
		return;
	}

	if (overlayGroup === TOUR_OVERLAY_GROUPS.deleteDashboardView) {
		closeDeleteDashboardViewDialog();
	}
}

export function resolveTourAdvanceOn({
	advanceOn,
	advanceWhenTarget,
}: {
	advanceOn?: "target-visible" | "target-click" | "none";
	advanceWhenTarget?: string;
}): "target-visible" | "target-click" | "none" {
	if (advanceOn) {
		return advanceOn;
	}

	if (advanceWhenTarget) {
		return "target-visible";
	}

	return "none";
}
